import { LoyaltyProfile, type UserEligibleData } from '@/domain/User';
import { Services } from '@/infra/services';

export async function getLoyaltyProfile(user: UserEligibleData) {
  const response = await Services.User.getLoyaltyProfile();

  const domainProps = {
    name: response.data.name,
    picture: response.data.picture,
    points: response.data.points,
    status: response.data.status,
    hasArchitectCashback: response.data.hasArchitectCashback,
  };

  return new LoyaltyProfile(user, domainProps);
}
